import addMinutes from 'date-fns/add_minutes'
import differenceInDays from 'date-fns/difference_in_days'
import differenceInSeconds from 'date-fns/difference_in_seconds'
import distanceInWordsStrict from 'date-fns/distance_in_words_strict'
import format from 'date-fns/format'
import getMinutes from 'date-fns/get_minutes'
import getMonth from 'date-fns/get_month'
import isToday from 'date-fns/is_today'

export const formatSmartTimestamp = timestamp => {
  const today = new Date()

  if (isToday(timestamp)) {
    // Return just now if the timestamp is less than 60 seconds
    if (differenceInSeconds(today, timestamp) < 60) {
      return 'just now'
    }

    // Return the amount of time if the timestamp is today
    return distanceInWordsStrict(today, timestamp, { addSuffix: true })
  }

  const elapsedDays = differenceInDays(today, timestamp)

  if (elapsedDays < 365) {
    // If less than a year, show timestamp with day + month
    return format(timestamp, 'D MMMM, HH:mm')
  }

  // Return the timestamp with year
  return format(timestamp, 'D MMMM YYYY, HH:mm')
}

export const formatSmartDate = timestamp => {
  const today = new Date()

  if (isToday(timestamp)) {
    // Return just now if the timestamp is less than 60 seconds
    if (differenceInSeconds(today, timestamp) < 60) {
      return 'just now'
    }

    // Return the amount of time if the timestamp is today
    return distanceInWordsStrict(today, timestamp, { addSuffix: true })
  }

  const elapsedDays = differenceInDays(today, timestamp)

  if (elapsedDays < 365) {
    // If less than a year, show date with day + month
    return format(timestamp, 'D MMMM')
  }

  // Return the date with year
  return format(timestamp, 'D MMMM YYYY')
}

export const formatDistanceInWords = timestamp => {
  const today = new Date()

  // Return 'just now' if the timestamp is less than 60 seconds
  if (differenceInSeconds(today, timestamp) < 60) {
    return 'just now'
  }

  // Return the amount of time between today and the timestamp
  return distanceInWordsStrict(today, timestamp, { addSuffix: true })
}

export const roundMinutesToStep = (date, step) => {
  const minuteModule = getMinutes(date) % step
  const minuteDifference = minuteModule < Math.ceil(step / 2) ? -minuteModule : step - minuteModule
  return addMinutes(date, minuteDifference)
}

export const IANATimeZoneName = () => {
  const dateInParts = new Intl.DateTimeFormat('en-US', { timeZoneName: 'long' }).formatToParts(new Date())

  return dateInParts.find(part => part.type === 'timeZoneName').value
}

const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

export const formatDateWithShortMonth = (timestamp, options = {}) => {
  if (!timestamp) return ''

  const { includeDay = true, includeTimestamp = false } = options

  const dayFormatString = includeDay ? 'D ' : ''
  const monthFormatString = months[getMonth(timestamp)].length <= 3 ? 'MMM' : 'MMM.'
  const timeFormatString = includeTimestamp ? ' [at] HH:mm' : ''

  return format(timestamp, `${dayFormatString}${monthFormatString} YYYY${timeFormatString}`)
}
